import styled from 'styled-components'

const Container = styled.div`
  
  max-width: 1423px;
  padding: 0 10px;
  margin: 0 auto;
  @media (max-width:1250px) {
      padding: 0 15px;
  }
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 237px 1fr;
  grid-column-gap: 46px;
  @media (max-width: 1250px) {
    grid-template-columns: 1fr;
    .pd-right-nav {
      display: none;
    }
  }
  
`;

export { Container, Wrapper };